import React, { FC } from 'react';
import { ThemeProvider, themeProviderProps } from './ThemeProvider';

export const AnvilProvider: FC<themeProviderProps> = ({ children, theme }) => {
	return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
